import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchDashboardData(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/dashboard', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
